import React from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import TransportTentIcon from "../../shared/icons/transport-type/awning.png";
import TransportCoveredIcon from "../../shared/icons/transport-type/covered.png";
import TransportIsothermIcon from "../../shared/icons/transport-type/isothermal.png";
import TransportRefrigeratorIcon from "../../shared/icons/transport-type/refrigerator.png";

import styleCommon from "../section-item/common.module.scss";
import styleLocal from "./style.module.scss";
import ActiveRadioButtonIcon from "../../shared/icons/ActiveRadioButtonIcon";
import InactiveRadioButtonIcon from "../../shared/icons/InactiveRadioButtonIcon";

const OrdersTransportType = ({
  text = "",
  style = {},
  isEditable = false,
  isSelected = false,
  isTagView = false,
  draft = false,
  type = "",
  onClick = () => void 0,
}) => {
  const { t } = useTranslation();

  // Function to get the translated text based on type
  const getTranslatedType = (typeKey) => {
    switch (typeKey) {
      case "awning":
        return t('transportType.awning');
      case "covered":
        return t('transportType.covered');
      case "isothermal":
        return t('transportType.isothermal');
      case "refrigerator":
        return t('transportType.refrigerator');
      default:
        return "";
    }
  };

  const displayText = text || (draft && !type ? t('transportType.notSpecified') : getTranslatedType(type));

  return (
    <div
      className={cn(styleLocal.transportType, styleLocal.cardItem, {
        [styleLocal.transportType_tagView]: isTagView,
        [styleLocal.transportType_editable]: isEditable,
        // [styleLocal.transportType_selected]: isSelected // Assuming selection logic is handled elsewhere
      })}
      style={style}
      onClick={onClick}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <img src={getIcon(type)} style={{ width: "40px", height: "40px" }} alt={displayText} />
        {isSelected ? <ActiveRadioButtonIcon /> : <InactiveRadioButtonIcon />}
      </div>
      {displayText}
    </div>
  );
};

const getIcon = (type) => {
  if (type === "awning") {
    return TransportTentIcon;
  } else if (type === "covered") {
    return TransportCoveredIcon;
  } else if (type === "isothermal") {
    return TransportIsothermIcon;
  } else if (type === "refrigerator") {
    return TransportRefrigeratorIcon;
  }
  return null; // Return null or a default icon if type is unknown
};

export default OrdersTransportType;
